import { deepClone } from "@/utils/"

export default {
	selectedNode(state, getters) {
		let selectedNode

		const recursion = arr => {
			arr.forEach(node => {
				if (node.id === state?.selectedNodeIds?.[0]) {
					selectedNode = node
					return
				}
				if (node?.children?.length) recursion(node.children)
			})
		}

		const selectedComponent = getters.selectedComponent
		recursion(selectedComponent?.editorAst ?? [])
		return selectedNode ? deepClone(selectedNode) : null
	},

	selectedComponent(state) {
		const selectedComponentId = state?.selectedComponentId
		const components = state?.app?.components ?? []

		return components.find(component => component.id === selectedComponentId) ?? {}
	}
}
